// extracted by mini-css-extract-plugin
export default {"actionsView":"styles_actionsView__8pb1k","singleAction":"styles_singleAction__wW6Uu","ui-spin":"styles_ui-spin__DvtWQ"};